import React from "react";
import {
  RouterProvider,
  Navigate,
  Routes,
  createHashRouter,
} from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import IRoute from "./IRoute";
import routes, { LoginPath } from "./routes";
import { isUserLoggedIn } from "./utils";

const PrivateRoute = ({ route }: { route: IRoute }): any => {
  const isAuthenticated = isUserLoggedIn();
  if (!isAuthenticated) {
    return <Navigate to={LoginPath} />;
  }
  return route.element && <route.element />;
};

export { PrivateRoute };

const getRoutes = (routeList: IRoute[]): any => {
  return routeList.map((route: IRoute, index) => {
    return {
      ...(route.index && { index: route.index }),
      ...(route.path && { path: route.path }),
      element: (
        <ErrorBoundary fallback={<div>Error Occured</div>}>
          {route.isProtected ? (
            <PrivateRoute key={index} route={route} />
          ) : typeof route.element === "string" ? (
            <Navigate to={LoginPath} replace />
          ) : (
            route.element && <route.element />
          )}
        </ErrorBoundary>
      ),
      ...(route.children && {
        children: [...getRoutes(route.children)],
      }),
      ...(route.errorElement && {
        errorElement: <route.errorElement />,
      }),
    };
  });
};

const router = createHashRouter(getRoutes(routes));

function App() {
  return <RouterProvider router={router} />;
}

export default App;
